import React from 'react'

export default function DownloadApp() {
    return (
        <section className="download_sc ub_spc">
            <div className="conta_iner">
                <div className="inner">
                    <div className="left_s uh_spc">
                        <h2>Download the App</h2>
                        <p>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.</p>
                        <div className="btn_flex">
                            <a href=" "><img src="/static/images/app_store_icon.png" alt=""/></a>
                            <a href=" "><img src="/static/images/google_play_icon.png" alt=""/></a>
                        </div>
                    </div>
                    <div className="right_s">
                        <figure><img src="/static/images/app_attachment.png" alt=""/></figure>
                    </div>
                </div>
            </div>
        </section>
    )
}
